<template>
  <BaseNoDataSection
    :title="$t('No Time Entries Found')"
    iconClass="fa-stopwatch"
    :canCreate="!isCurrentProjectClosed && can($actions.CREATE_TIME_ENTRIES)"
  >
    <template #can-create-section>
      <div>{{ $t('Keep track of allocated & actual time spent on projects.') }}</div>
      <div>{{ $t('Filter, group & sort. Then view in a chart to analyze.') }}</div>
      <!-- TODO: Fix clicking this button opens the dialog twice -->
      <div
        class="hover:text-primary-500 cursor-pointer"
        @click.stop="$store.commit('time/triggerAddTimeEntry')"
      >
        {{ $t('Create a new time entry') }}
        <i class="fa-solid fa-arrow-right" aria-hidden="true" />
      </div>
    </template>
  </BaseNoDataSection>
</template>
<script>
export default {
  computed: {
    isCurrentProjectClosed() {
      return this.$store.getters['projects/isCurrentProjectClosed']
    },
  },
}
</script>  
